import { VehicleCleanlinessExtent, VehicleDamageExtent } from "@/core/api/generated/v1/api";

export const cleanlinessTags: (keyof typeof VehicleCleanlinessExtent)[] = [
  VehicleCleanlinessExtent.SlightlyDirty,
  VehicleCleanlinessExtent.ModerateDirty,
  VehicleCleanlinessExtent.VeryDirty,
  VehicleCleanlinessExtent.ExtremelyDirty,
];

export const damageTags: (keyof typeof VehicleDamageExtent)[] = [
  VehicleDamageExtent.VeryMinor,
  VehicleDamageExtent.Minor,
  VehicleDamageExtent.Moderate,
  VehicleDamageExtent.Severe,
  VehicleDamageExtent.VerySevere,
];
